import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import {
  PostAprovarMedicaoDto,
  PostPrintExportMedicaoDto,
  PostReprovarMedicaoDto,
} from '@app/data/medicoes/dto';
import { MedicaoRepository } from '@app/data/medicoes/medicao.repository';
import { MedicaoModel } from '@app/data/medicoes/models';

@Injectable()
export class MedicoesController extends BaseController<MedicaoModel> {
  constructor(protected medicaoRepository: MedicaoRepository) {
    super(medicaoRepository);
  }

  aprovarMedicao(params: PostAprovarMedicaoDto) {
    return this.medicaoRepository.aprovarMedicao(params);
  }

  reprovarMedicao(params: PostReprovarMedicaoDto) {
    return this.medicaoRepository.reprovarMedicao(params);
  }

  imprimirExportarMedicao(params: PostPrintExportMedicaoDto) {
    return this.medicaoRepository.imprimirExportarMedicao(params);
  }
}
